import { SaveButton, TabContentWrapper } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { Form, Layout, Skeleton, notification, Empty, Typography } from 'antd';

import { Helmet } from 'react-helmet';

import './style.less';

import logo from '@/assets/images/Logo_Footer.png';
import logoMin from '@/assets/images/Logo-UC-mobile.png';
import { useWindowSize } from '@/hooks';
import { useRouteMatch } from 'react-router-dom';
import {
  useQuotationOffersPublic,
  useQuotationOffersPublicSend,
} from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.hooks';
import QuotationsRequest from '@/components/Movements/Quotations/QuotationsRequest';
import React, { useEffect } from 'react';
import {
  QuotationsOffersPublicFormValues,
  QuotationsOffersPublicSend,
} from '@/core/domain/stock/QuotationsOffers/QuotationsOffers.types';
import EmailSentImage from '@/assets/images/email_sent.png';
import { isAppPortocar } from '@/index';
import SystemFooter from '@/components/_common/SystemFooter';

function QuotationRequestPage() {
  const [form] = Form.useForm<QuotationsOffersPublicFormValues>();
  const { isMobile } = useWindowSize();
  const { guid } = useRouteMatch<{ guid: string }>().params;

  const { data, isFetching, dataUpdatedAt } = useQuotationOffersPublic(guid);
  const sendMutation = useQuotationOffersPublicSend();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        items: data?.result.items.map((item) => ({
          ...item,
          valueTotal:
            (((item.quantity ?? 0) * (item.unitCost ?? 0)) / 100) *
            (100 - (item.discount ?? 0)),
        })),
      });
    }
  }, [dataUpdatedAt]);

  const handleSendQuotation = async () => {
    const values = await form.validateFields();

    if (
      values.items.every((item) =>
        item.deliverDays ? item.deliverDays <= 0 : true,
      )
    ) {
      return notification.error({
        message: 'Informe a entrega maior que zero.',
      });
    }

    const obj: QuotationsOffersPublicSend = {
      code: guid,
      freight: values.freight,
      observation: values.observation,
      paymentFormat: values.paymentFormat,
      items: values.items.map((item) => ({
        ...item,
        discount: (item.discount ?? 0) / 100,
      })),
    };

    await sendMutation.mutateAsync(obj);
  };

  return (
    <>
      <Helmet title={'Pedido Cotação'} />

      <Layout.Header className="app-header">
        <div className="app-header-content" style={{ maxWidth: '100%' }}>
          {isMobile ? (
            <div className="logoMin">
              <img
                className="image"
                src={
                  isAppPortocar
                    ? '/images/Logo_PortoCar_branca-icon.svg'
                    : logoMin
                }
                alt="logo"
                style={{ width: '60px' }}
              />
            </div>
          ) : (
            <div className="logo">
              <img
                className="image"
                src={isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo}
                alt="logo"
              />
            </div>
          )}
        </div>
      </Layout.Header>

      <div style={{ marginTop: '90px', marginBottom: '90px' }}>
        <TabContentWrapper
          title={'quotations.request'}
          permissions={[]}
          extra={
            <SpaceForButton>
              <SaveButton
                block
                type="primary"
                onClick={handleSendQuotation}
                loading={sendMutation.isLoading}
                disabled={data?.result.answered}
              >
                Enviar
              </SaveButton>
            </SpaceForButton>
          }
        >
          {data?.result.answered ? (
            <Empty
              image={EmailSentImage}
              imageStyle={{ height: 130 }}
              description={
                <Typography.Title>Enviado com sucesso!</Typography.Title>
              }
            />
          ) : (
            <Skeleton loading={isFetching}>
              <Form form={form}>
                <QuotationsRequest data={data} />
              </Form>
            </Skeleton>
          )}
        </TabContentWrapper>
      </div>

      <SystemFooter />
    </>
  );
}

export default QuotationRequestPage;
